export const Logo = ({ className = "", size = "default" }) => {
  const sizeClasses = {
    small: "h-24",
    default: "h-28 sm:h-40 lg:h-48",
    large: "h-56"
  };

  return (
    <div className={`flex items-center ${className}`} data-testid="logo">
      <img 
        src="https://customer-assets.emergentagent.com/job_physio-letters/artifacts/3vkvm70p__Blue%20and%20Red%20Flat%20Minimal%20Write%20Club%20Logo.png"
        alt="Phisioletters Mail Club"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default Logo;
